import axios from 'axios';
import React from 'react';
import { enqueueSnackbar } from 'notistack';
import { ServiceTypeModel } from 'src/models/services/serviceType';
import { API_url } from '../api.setup';

const API_Controller = '/ServiceType';

export const ServiceTypeService = {
  getAllServiceType: async () => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getall`);
      return response.data as ServiceTypeModel[];
    } catch (error) {
      throw error;
    }
  },

  addServiceType: async (areaToUpdate: ServiceTypeModel) => {
    try {
      const response = await axios.post(
        `${API_url}${API_Controller}`,
        areaToUpdate
      );
      enqueueSnackbar(`State ${areaToUpdate.name} Added Successfully`, {
        variant: 'success'
      });
      return response.data as ServiceTypeModel;
    } catch (error) {
      enqueueSnackbar(`City ${areaToUpdate.name} Added Successfully`, {
        variant: 'error'
      });
      throw error;
    }
  },

  deleteServiceType: async (ServiceTypeId) => {
    try {
      const response = await axios.delete(
        `${API_url}${API_Controller}/delete?id=${ServiceTypeId}`
      );
      enqueueSnackbar(`Service type deleted Successfully`, {
        variant: 'success'
      });
      return response.data as ServiceTypeModel;
    } catch (error) {
      console.error('Error deleting data:', error);
      throw error;
    }
  },

  editServiceType: async (editedData: ServiceTypeModel) => {
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/update`,
        editedData
      );
      enqueueSnackbar(
        `Service Type " ${editedData.name} " Edited Successfully`,
        {
          variant: 'success'
        }
      );
      return response.data as ServiceTypeModel;
    } catch (error) {
      enqueueSnackbar(
        `Error Occurred Will Editing Service Type " ${editedData.name} "`,
        {
          variant: 'error'
        }
      );
      throw error;
    }
  }
};
